module.exports = __webpack_public_path__ + "static/media/contactMail.d6d4086f.png";